import { render } from "./VerifyEmail.vue?vue&type=template&id=9f895776"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "9f895776"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f895776', script)) {
    api.reload('9f895776', script)
  }
  
  module.hot.accept("./VerifyEmail.vue?vue&type=template&id=9f895776", () => {
    api.rerender('9f895776', render)
  })

}

script.__file = "resources/js/Pages/Auth/VerifyEmail.vue"

export default script